<template>
  <div class="text-center ma-2">
    <v-snackbar
      v-model="snackbarControl"
      :timeout="4000"
      :class="globalSnackbar.class"
      :dark="$vuetify.theme.dark"
      :light="!$vuetify.theme.dark"
      :style="{ visibility: visibilityControl ? 'visible' : 'hidden' }"
    >
      <div class="snackbar-content">
        <v-img
          v-if="snackbarIconSrc"
          :src="snackbarIconSrc"
          class="snackbar-icon"
          width="24"
          height="24"
        />
        <span class="snackbar-text">{{ globalSnackbar.text }}</span>
      </div>
      <template v-slot:action="{ attrs }">
        <template
          v-if="globalSnackbar.buttons && globalSnackbar.buttons.length"
        >
          <BaseBtn
            v-for="(button, index) in globalSnackbar.buttons"
            :key="index"
            :type="button.type || 'primary'"
            :color="button.color"
            :class="button.class"
            :style="button.style"
            @click="button.onClick"
            v-bind="attrs"
          >
            {{ button.text }}
          </BaseBtn>
        </template>
        <template v-if="globalSnackbar.links && globalSnackbar.links.length">
          <div
            v-for="(link, index) in globalSnackbar.links"
            :key="index"
            class="snack--link ml-8 mr-2"
            style="padding-bottom: 2px"
          >
            <a
              class="text-decoration-none"
              :href="link.href"
              @click="handleClose"
            >
              {{ link.text }}
              <v-icon v-if="link.icon" size="12px" end>{{
                link.icon.mdi
              }}</v-icon>
            </a>
          </div>
        </template>
        <v-btn
          v-if="!globalSnackbar.removeCloseButton"
          icon
          width="16px"
          height="16px"
          v-bind="attrs"
          @click="handleClose"
        >
          <v-icon size="16px">mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import BaseBtn from '@/components/BaseBtn.vue'

export default {
  name: 'Snackbar',
  components: {
    BaseBtn,
  },
  data: () => ({
    snackbarControl: null,
    snackIconsPath: {
      info: require('@/assets/snackbar/icons/info-solid.svg'),
      success: require('@/assets/snackbar/icons/check-round.svg'),
      warning: require('@/assets/snackbar/icons/alert-solid.svg'),
      error: require('@/assets/snackbar/icons/error-solid.svg'),
    },
    visibilityControl: true,
  }),
  computed: {
    ...mapState('user', ['globalSnackbar']),
    snackbarType() {
      return this.globalSnackbar.type || 'info'
    },
    snackbarIconSrc() {
      return this.snackIconsPath[this.snackbarType]
    },
  },
  mounted() {
    this.preloadSvg()
  },
  watch: {
    'globalSnackbar.open': {
      immediate: true,
      deep: true,
      handler(isOpen) {
        if (isOpen) {
          this.visibilityControl = true
          this.handleSnackbarClass()
          setTimeout(() => {
            this.snackbarControl = isOpen
          }, 500)
        } else {
          this.snackbarControl = isOpen
        }
      },
    },
  },
  methods: {
    ...mapMutations('user', ['UPDATE_GLOBAL_SNACKBAR']),
    handleClose() {
      this.visibilityControl = false
      this.UPDATE_GLOBAL_SNACKBAR({
        open: false,
        text: '',
        type: '',
        class: '',
        buttons: [],
        links: [],
      })
    },
    handleSnackbarClass() {
      if (this.globalSnackbar.class) {
        this.globalSnackbar.class += ' snack--' + this.snackbarType
      } else {
        this.globalSnackbar.class = 'snack--' + this.snackbarType
      }
    },
    preloadSvg() {
      Object.keys(this.snackIconsPath).forEach((key) => {
        const img = new Image()
        img.src = this.snackIconsPath[key]
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.snack--nowrap {
  white-space: nowrap;
}
::v-deep .snack--disable-max-width {
  .v-snack__wrapper {
    max-width: none;
  }
}
::v-deep .v-snack__wrapper .v-snack__content {
  padding: 8px 12px 8px 8px;
}
::v-deep .v-snack__wrapper {
  border-radius: 20px !important;
  box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.15) !important;
}
::v-deep .snack--warning .v-snack__wrapper {
  &.theme--dark {
    background-color: #3d2300;
    border: 1px solid #ffc71f !important;
  }
  &.theme--light {
    background-color: #fff8f0;
    border: 1px solid #ffc107 !important;
  }
}
::v-deep .snack--info .v-snack__wrapper {
  &.theme--dark {
    background-color: #2f3037;
    border: 1px solid #051161 !important;
  }
  &.theme--light {
    border: 1px solid #d0d1d9 !important;
    background: #fff;
  }
}
::v-deep .snack--success .v-snack__wrapper {
  &.theme--dark {
    border: 1px solid #4caf50 !important;
    background: #003303;
  }
  &.theme--light {
    border: 1px solid #4caf50 !important;
    background: #f5fff5;
  }
}
::v-deep .snack--error .v-snack__wrapper {
  &.theme--dark {
    border: 1px solid #f44336 !important;
    background: #300;
  }
  &.theme--light {
    border: 1px solid #f44336 !important;
    background: #fff5f5;
  }
}
.snackbar-content {
  display: flex;
  align-items: center;
}
.snackbar-icon {
  margin-right: 10px;
  flex: none;
}
.snackbar-text {
  display: inline-block;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
}
.snack--link {
  i {
    color: var(--v-primary-base);
  }
  a {
    font-size: 12px;
  }
}
</style>
